import React from 'react';

export function NewSquadButton({ isCreatingNew, onCreateNew }) {
  return (
    <button
      onClick={onCreateNew}
      disabled={isCreatingNew}
      className="w-full rounded-lg bg-[#4ADE80] px-6 py-3 font-semibold text-[#050505] transition-colors hover:bg-[#3bc96a] disabled:cursor-not-allowed disabled:opacity-50"
    >
      {isCreatingNew ? 'Creating new squad...' : 'Start a new squad'}
    </button>
  );
}
